import axios from "axios";
import { toast } from "react-toastify";

// Set the custom header globally
axios.defaults.headers.common["x-request-platform"] = "panel";
axios.defaults.headers.common["x-app-version"] = "2.0.0";
axios.defaults.withCredentials = true;

const SESSION_FLAG_STORAGE_KEY = "orgId";

const buildHeaders = incomingHeaders => {
  const headers = { ...(incomingHeaders || {}) };
  if (typeof window !== "undefined") {
    const flag = localStorage.getItem(SESSION_FLAG_STORAGE_KEY);
    if (flag !== null) {
      headers["x-session-exists"] = "true";
    }
  }
  return headers;
};

const fetchApi = async (method, url, options = {}) => {
  try {
    const response = await axios({
      method,
      url,
      ...options,
      // headers: buildHeaders(options.headers),
      withCredentials: true, // cookies for refresh flow
    });
    return response.data;
  } catch (error) {
    const status = error?.response?.status;
    // Handle network/CORS/timeouts (no response object)
    if (!status) {
      // Avoid spamming toast for specific background checks if needed
      toast.error("ارتباط با سرور برقرار نشد.");
      throw error;
    }

    if (error.response.status === 401 && !url.includes("/auth/auth-check")) {
      try {
        const refreshUrl = `${
          window?.location?.origin?.includes("localhost")
            ? `${process.env.REACT_APP_DEV_URL}`
            : `${process.env.REACT_APP_API_URL}`
        }/auth/refresh`;

        await axios.post(
          refreshUrl,
          {
            params: {
              orgId: localStorage.getItem("orgId"),
            },
          },
          {
            withCredentials: true,
            // headers: buildHeaders(),
          }
        );

        // ✅ Retry original request after token is set
        return await fetchApi(
          method,
          url,
          {
            ...options, // keep original params/data/responseType/etc.
            headers: {
              ...(options.headers || {}),
            },
          },
          true
        );
      } catch (error) {
        if (error?.response?.status === 401) {
          toast.info(`لطفا مجدد لاگین کنید!`);
          localStorage.clear();
          setTimeout(() => {
            window.location.replace(
              `/?login=true&redirect=${
                window.location.pathname + window.location.search
              }`
            );
          }, 500);
        }
      }
    } else if (!url.includes("/auth/auth-check"))
      toast.error(error?.response?.data?.message);
    throw error;
  }
};
export default fetchApi;
